export default "__VITE_ASSET__DWWFuD9i__"